// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__alKZS","iconWithCounter":"styles_iconWithCounter__LnrtX","counterForLabel":"styles_counterForLabel__hFCkT","counterForIcon":"styles_counterForIcon__5t0PX"};